import React, {useState} from 'react';
// import CityEmbed from "./components/city/city";
// import AllEmbed from "./components/all/all";
// import Compare from './components/compare/compare';
// import MapEmbed from "./components/map/map";
import CountryDataMap from './components/contry-data/country-data-map';
import GrowthGraph from './components/growth/growth';
import MigrationGraph from './components/migration/migration';
import MigrationFlow from './components/flow/flow';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.scss';
import './App.scss';

function App() {
  const [tabIndex, setTabIndex] = useState(0);
  const [tabName, setTabName] = useState('HNWI Inflow & Outflow');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const onSelect = (index, lastIndex, event) =>{
    setTabIndex(index);
    setTabName(event.target.innerText);
  }

  const handleMenuClick = () =>{
      setMobileMenuOpen(!mobileMenuOpen)
  }

  return (
    <div className="App">
      <div className="appContainer">
        <div className="container-fluid">
          <h2 className="top-title">Henley Private Wealth Migration Dashboard</h2>
        </div>
      </div>
     
      <Tabs className="Tabs" selectedIndex={tabIndex} onSelect={(index, lastIndex, event) => onSelect(index, lastIndex, event)}>
        <div className={`mobile-menu-wrapper ${mobileMenuOpen ? 'open' : ''}`} >
        
            <button className="mobile-menu-button" onClick={handleMenuClick}>
              <span className="dropdown-text">
                {tabName}
              </span>
              <span className="dropdown-icon">
                <svg viewBox="0 0 15 10">
                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g transform="translate(-421.000000, -159.000000)" fill="currentColor">
                            <g transform="translate(30.000000, 146.000000)">
                                <g transform="translate(391.000000, 13.000000)" >
                                    <polygon points="0 0 14.1525753 0 7.07628767 9.704041"></polygon>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
              </span>
            </button>
            <div className="menu-list" onClick={() => setMobileMenuOpen(false)}>
              <TabList>
                <Tab><span>HNWI Inflows & Outflows</span></Tab>
                <Tab><span>HNWI Migration</span></Tab>
                <Tab><span>HNWI Growth</span></Tab>
                <Tab><span>HNWI Country Data</span></Tab>
              </TabList>
            </div>
        
        </div>
        <TabPanel>
          <MigrationFlow />
        </TabPanel>
        <TabPanel>
          <MigrationGraph />
        </TabPanel>
        <TabPanel>
          <GrowthGraph />
        </TabPanel>
        <TabPanel>
          <CountryDataMap />
        </TabPanel>
     </Tabs>

      
    </div>
  );
}

export default App;
